export default __webpack_public_path__ + "media/images/8-e21f05195cfbe0762bfd3b8f1bfe1cd7.jpg";